import { render, staticRenderFns } from "./WarnPeople.vue?vue&type=template&id=6aa93f9c"
import script from "./WarnPeople.vue?vue&type=script&lang=js"
export * from "./WarnPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports